(function () {
  'use strict';

  if (window.AxiomCollapsible) return;
  window.AxiomCollapsible = true;

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest && event.target.closest('[data-product-collapsible-trigger]');
    if (!trigger) return;

    var collapsible = trigger.closest('[data-product-collapsible]');
    if (!collapsible) return;

    var expanded = !collapsible.classList.contains('is-open');
    collapsible.classList.toggle('is-open', expanded);
    trigger.setAttribute('aria-expanded', String(expanded));
  });
})();
